module.exports = __webpack_public_path__ + "static/assets/c0878b928f59a5f14d0436a4748a8731.png";